import { AccountId } from "../../spread/types";
export enum FormulaTokenType {
  Id = "Id",
  Operation = "Operation",
  End = "End"
}
export enum FormulaOperation {
  Add = "Add",
  Subtract = "Subtract"
}
export interface IdToken {
  type: FormulaTokenType.Id;
  value: AccountId;
  next: OperationToken | EndToken;
}
export interface OperationToken {
  type: FormulaTokenType.Operation;
  value: FormulaOperation;
  next: IdToken;
}
export interface EndToken {
  type: FormulaTokenType.End;
}
export type Token = IdToken | OperationToken | EndToken;
export type Formula = IdToken;
export enum ParseResultType {
  Ok = "Ok",
  Error = "Error"
}
export type FormulaError = string;
export type ParseResult =
  | [ParseResultType.Ok, Formula]
  | [ParseResultType.Error, FormulaError];
export type PartialParseResult =
  | {
      status: ParseResultType.Ok;
      result: Token;
    }
  | {
      status: ParseResultType.Error;
      result: FormulaError;
    };

export type Multiplier = 1 | -1;
export type ReducedFormula = Array<[Multiplier, string]>;



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/formulas/types.ts